import { MiniInterviewType } from 'src/packages/polaris/types';

export const BACK_BUTTON_ENABLED_INTERVIEW_TYPES: MiniInterviewType[] = [
  'treatmentGuidance',
  'txoc',
  'pxoc',
  'dxoc',
  'symptoms',
  'emergency',
];
